export const downloadImage = (svg, width, height, filename) => {
    return new Promise((resolve, reject) => {
        reject(new Error("Not Implemented"));
    });
};
export const exportToCsv = (headers, data, filename) => {
    const csvData = [headers, ...data].map((row) => `${row.join(",")}\r\n`);
    saveFile(filename, new Blob(csvData, { type: "text/csv" }));
};
export const saveFile = (filename, blob) => {
    const a = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);
    a.href = window.URL.createObjectURL(blob);
    a.setAttribute("download", filename);
    a.click();
    window.URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
};
//# sourceMappingURL=exporters.js.map